"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletFactory = void 0;
const Error_1 = require("../Error");
const EoaWallet_1 = require("./EoaWallet");
const KernelSmartWallet_1 = require("./smart-wallet/KernelSmartWallet");
class WalletFactory {
    static from(config) {
        if ('eoa' in config) {
            return Promise.resolve(EoaWallet_1.EoaWallet.create(config));
        }
        if ('kernel' in config) {
            return KernelSmartWallet_1.KernelSmartWallet.create(config);
        }
        throw new Error_1.KriptonioError({ message: 'invalid wallet config' });
    }
}
exports.WalletFactory = WalletFactory;
